module.exports = __webpack_public_path__ + "assets/fondssuisse.36240bfd79b73cd1fca381604ea23495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fondssuisse.png
// module id = oMHv
// module chunks = 0